import React, { Fragment} from 'react'
import PageHeadline from '../Headlines/PageHeadline'
import InAppNav from '../../Components/InAppNav/InAppNav'


// Props needs
// 
const DefaultPage = (props) => {
   const { headline, children } = props
   const { headlineText, headlineSubtext} = headline
    
    return <Fragment>
               <PageHeadline headline={headlineText} subtext={headlineSubtext} />
               <InAppNav handleOnClick={props.handleOnClick} links={props.links}/>
               {children}

            </Fragment>
}

export default DefaultPage


// WEBPACK FOOTER //
// ./src/Container/Layout/DefaultPage.js